import Api from '../../../shared/Api';
import { IImageEditorFirm } from '../Entities';

class ImageEditorFirmsApi {
    static getImageEditorFirms(): any {
        return new Api().get('/views/imageeditorfirms');
    }

    static saveImageEditorFirm(imageEditorFirm: IImageEditorFirm): any {
        return new Api().post('/views/imageeditorfirms', {
            name: imageEditorFirm.name,
            downloadStorageKey: imageEditorFirm.downloadStorageKey,
            brokerFirmDefault: imageEditorFirm.brokerFirmDefault,
            brokerFirmDefaultExpress: imageEditorFirm.brokerFirmDefaultExpress
        });
    }

    static getImageEditorFirm(id: number): any {
        return new Api().get(`/views/imageeditorfirms/${id}/edit`);
    }

    static updateImageEditorFirm(imageEditorFirm: IImageEditorFirm): any {
        return new Api().put(`/views/imageeditorfirms/${imageEditorFirm.id}`, {
            id: imageEditorFirm.id,
            name: imageEditorFirm.name,
            downloadStorageKey: imageEditorFirm.downloadStorageKey,
            isDiscontinued: imageEditorFirm.isDiscontinued,
            brokerFirmDefault: imageEditorFirm.brokerFirmDefault,
            brokerFirmDefaultExpress: imageEditorFirm.brokerFirmDefaultExpress
        });
    }

    static ChangeIsDiscontinuedDiscontinued(id: number, isDiscontinued: number) {
        return new Api().put(`/views/imageeditorfirms/${id}/changeDiscontinued`, {
            isDiscontinued: isDiscontinued
        });
    }
}

export default ImageEditorFirmsApi;
